export default __webpack_public_path__ + "static/technical-development-5d4ee072becfdad8d0aa30a45de7afda.webp";